import React from "react";
import { useState, useEffect } from "react";
import {
  Box,
  Typography,
  Divider,
  TextField,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Button,
  Alert,
  Snackbar,
  CircularProgress,
  InputAdornment
} from "@mui/material";

import { MdDeleteOutline } from "react-icons/md";
import { MdOutlineModeEdit } from "react-icons/md";
import { useGetAllCarsQuery, useDeleteCarMutation, useUpdateCarMutation } from "../../../redux/slices/admin/machine/addCarSlince.js";
import { useOutletContext } from "react-router-dom";
import { Pagination } from "@mui/material"
import "../../../styles/admin.css/machine-modifications-css/manage-cars.css";

export default function ManageCars({ showDelete = true }) {
  const { sidebarOpen } = useOutletContext();
  const [page, setPage] = useState(1);
  const itemsPerPage = 50;

  const { data, isLoading, refetch } = useGetAllCarsQuery(undefined, {
    refetchOnMountOrArgChange: true,
  });
  const cars = data?.data || [];
  const [deleteCar, { isLoading: isDeleting }] = useDeleteCarMutation();

  const [updateCar] = useUpdateCarMutation();

  const [search, setSearch] = useState("");
  const [openRow, setOpenRow] = useState(null);
  const [mode, setMode] = useState(null);
  const [editValues, setEditValues] = useState({});
  const [deletingId, setDeletingId] = useState(null);

  const normalize = (val = "") => val.replace(/-/g, "").toLowerCase();

  const filteredCars = cars.filter((car) => {
    const s = normalize(search);

    const model = normalize(car?.model || "");
    const plate = normalize(car?.plateNumber || "");
    const firstName = normalize(car?.firstName || "");
    const lastName = normalize(car?.lastName || "");
    const phone = normalize(car?.phone || "");

    return (
      model.includes(s) ||
      plate.includes(s) ||
      firstName.includes(s) ||
      lastName.includes(s) ||
      phone.includes(s)
    );
  });

  const totalPages = Math.ceil(filteredCars.length / itemsPerPage);
  const startIndex = (page - 1) * itemsPerPage;
  const paginatedCars = filteredCars.slice(startIndex, startIndex + itemsPerPage);

  const [errors, setErrors] = useState({});
  const [toast, setToast] = useState({ open: false, severity: "success", message: "" });

  const handleCloseToast = () => {
    setToast({ ...toast, open: false });
  };
  useEffect(() => {
    setPage(1);
  }, [search]);

  const handleDelete = (carId) => {
    setDeletingId(carId);
    deleteCar(carId)
      .unwrap()
      .then(() => {
        setToast({ open: true, severity: "success", message: "Silindi" });
        refetch();
      })
      .catch(() => {
        setToast({ open: true, severity: "info", message: "Silərkən xəta baş verdi!" });
      })
      .finally(() => {
        setDeletingId(null);
      });
  };



  const handleEditClick = (car) => {
    if (openRow === car.id && mode === "edit") {
      setOpenRow(null);
      setMode(null);
      setEditValues({});
    } else {
      setOpenRow(car.id);
      setMode("edit");

      const firstName = car.firstName || "";
      const lastName = car.lastName || "";

      setEditValues({
        ...car,
        firstName: firstName,
        lastName: lastName,
        phoneNumber: car.phone || "",
      });
    }
  };

  const handleInputChange = (field, value) => {
    setEditValues((prev) => ({ ...prev, [field]: value }));
  };

  const handleCancel = () => {
    setOpenRow(null);
    setMode(null);
    setEditValues({});
  };

  const handleSave = async () => {

    if (
      !editValues.firstName?.trim() ||
      !editValues.lastName?.trim() ||
      !editValues.model?.trim() ||
      !editValues.phoneNumber?.trim() ||
      !editValues.plateNumber?.trim()
    ) {
      setToast({
        open: true,
        severity: "error",
        message: "Heç bir sahə boş ola bilməz!",
      });
      return;
    }

    const updatedCar = {
      id: editValues.id,
      firstName: editValues.firstName.trim(),
      lastName: editValues.lastName.trim(),
      phone: editValues.phoneNumber.trim(),
      plateNumber: editValues.plateNumber.trim(),
      model: editValues.model.trim(),
    };

    try {
      await updateCar(updatedCar).unwrap();
      setToast({
        open: true,
        severity: "success",
        message: "Uğurla yeniləndi!",
      });
      refetch();
      setOpenRow(null);
      setMode(null);
      setEditValues({});
    } catch (err) {
      setToast({
        open: true,
        severity: "error",
        message: "Yeniləmə zamanı xəta baş verdi!",
      });
    }
  };


  return (
    <Box
      className={`employees-container ${sidebarOpen ? "sidebar-open" : ""
        }`}
    >
      <Box className="header-row">
        <Box className="left-title">
          <Typography style={{ color: "#545A61" }}>
            Maşınların idarə edilməsi
          </Typography>
          <Divider className="employees-divider" />
        </Box>

        <TextField
          size="small"
          placeholder="Axtar..."
          className="search-input"
          value={search}
          onChange={(e) => setSearch(e.target.value)}
        />
      </Box>

      <TableContainer component={Paper} className="employees-table">
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>
                <strong>#No</strong>
              </TableCell>
              <TableCell>
                <strong>Tam Ad</strong>
              </TableCell>
              <TableCell>
                <strong>Əlaqə nömrəsi</strong>
              </TableCell>
              <TableCell>
                <strong>Model</strong>
              </TableCell>
              <TableCell>
                <strong>Nömrə nişanı</strong>
              </TableCell>
              <TableCell>
                <strong>Seçimlər</strong>
              </TableCell>
            </TableRow>
          </TableHead>

          <TableBody>
            {isLoading ? (
              <TableRow>
                <TableCell colSpan={6} align="center">
                  Yüklənir...
                </TableCell>
              </TableRow>
            ) : filteredCars.length === 0 ? (
              <TableRow>
                <TableCell colSpan={6} align="center">
                  Məlumat tapılmadı
                </TableCell>
              </TableRow>
            ) : (
              paginatedCars.map((car, index) => (
                <React.Fragment key={car.id}>
                  <TableRow>
                    <TableCell>
                      {"#" + String(car.serialNo || (startIndex + index + 1)).padStart(4, "0")}
                    </TableCell>
                    <TableCell>{car.firstName} {car.lastName}</TableCell>
                    <TableCell>
                      <strong>+994 {car.phone}</strong>
                    </TableCell>
                    <TableCell>{car.model}</TableCell>
                    <TableCell>{car.plateNumber}</TableCell>

                    <TableCell className="manage-wrapper">
                      <Button
                        variant="contained"
                        size="small"
                        className="btn-edit"
                        onClick={() => handleEditClick(car)}
                      >
                        <MdOutlineModeEdit
                          style={{ width: "24px", height: "24px" }}
                        />
                      </Button>




                      {showDelete && (
                        <Button
                          variant="contained"
                          size="small"
                          className="btnn-delete"
                          onClick={() => handleDelete(car.id)}
                          disabled={deletingId === car.id}
                        >
                          {deletingId === car.id ? (
                            <CircularProgress size={24} color="white" />
                          ) : (
                            <MdDeleteOutline style={{ width: "24px", height: "24px" }} />
                          )}
                        </Button>
                      )}
                    </TableCell>
                  </TableRow>

                  {openRow === car.id && mode === "edit" && (
                    <TableRow key={`edit-${car.id}`}>
                      <TableCell colSpan={6} className="expanded-row-cell">
                        <Box className="expanded-details">

                          <TextField
                            label="Ad"
                            size="small"
                            fullWidth
                            value={editValues.firstName}
                            onChange={(e) =>
                              handleInputChange(
                                "firstName",
                                e.target.value.replace(/[^\p{L}\s]/gu, "")
                              )
                            }
                            onBlur={() => {
                              if (!editValues.firstName)
                                handleInputChange(
                                  "firstName",
                                  car.firstName || ""
                                );
                            }}
                            margin="dense"
                          />


                          <TextField
                            label="Soyad"
                            size="small"
                            fullWidth
                            value={editValues.lastName}
                            onChange={(e) =>
                              handleInputChange(
                                "lastName",
                                e.target.value.replace(/[^\p{L}\s]/gu, "")
                              )
                            }

                            onBlur={() => {
                              if (!editValues.lastName)
                                handleInputChange(
                                  "lastName",
                                  car.lastName || ""
                                );
                            }}
                            margin="dense"
                          />


                          <TextField
                            label="Əlaqə nömrəsi"
                            size="small"
                            fullWidth
                            value={editValues.phoneNumber}
                            onChange={(e) => {
                              const val = e.target.value.replace(/\D/g, "");
                              if (val.length <= 10)
                                handleInputChange("phoneNumber", val);
                            }}
                            onBlur={() => {
                              if (!editValues.phoneNumber)
                                handleInputChange(
                                  "phoneNumber",
                                  car.phone
                                );
                            }}
                            InputProps={{
                              startAdornment: (
                                <InputAdornment position="start">
                                  +994
                                </InputAdornment>
                              ),
                              inputMode: "numeric",
                            }}
                            margin="dense"
                          />

                          <TextField
                            label="Model"
                            size="small"
                            fullWidth
                            value={editValues.model}
                            onChange={(e) =>
                              handleInputChange(
                                "model",
                                e.target.value.replace(/[^A-Za-z0-9\s]/g, "")
                              )
                            }
                            onBlur={() => {
                              if (!editValues.model)
                                handleInputChange("model", car.model);
                            }}
                            margin="dense"
                          />

                          <TextField
                            label="Nömrə nişanı"
                            size="small"
                            fullWidth
                            value={editValues.plateNumber}
                            onChange={(e) => {
                              let raw = e.target.value
                                .toUpperCase()
                                .replace(/[^A-Z0-9]/g, "");

                              let p1 = raw.slice(0, 2).replace(/\D/g, "");
                              let p2 = raw.slice(2, 4).replace(/[^A-Z]/g, "");
                              let p3 = raw.slice(4, 7).replace(/\D/g, "");

                              let formatted = p1;
                              if (raw.length > 2) formatted += "-" + p2;
                              if (raw.length > 4) formatted += "-" + p3;

                              handleInputChange("plateNumber", formatted);
                            }}
                            onBlur={() => {
                              if (!editValues.plateNumber)
                                handleInputChange(
                                  "plateNumber",
                                  car.plateNumber
                                );
                            }}
                            inputProps={{
                              inputMode: "text",
                              pattern: "[0-9A-Z]*",
                            }}
                            margin="dense"
                          />

                          <Box className="edit-actions">
                            <Button
                              variant="outlined"
                              size="small"
                              onClick={handleCancel}
                            >
                              Ləğv et
                            </Button>

                            <Button
                              variant="contained"
                              size="small"
                              color="primary"
                              onClick={handleSave}
                            >
                              Təsdiqlə
                            </Button>
                          </Box>
                        </Box>
                      </TableCell>
                    </TableRow>
                  )}
                </React.Fragment>
              ))
            )}
          </TableBody>
        </Table>
      </TableContainer>
      {filteredCars.length > itemsPerPage && (
        <Box sx={{ display: "flex", justifyContent: "right", p: 2, mt: 2 }}>
          <Pagination
            count={totalPages}
            page={page}
            onChange={(e, value) => {
              setPage(value);
              window.scrollTo({ top: 0, behavior: "smooth" });
            }}
            color="primary"
            variant="outlined"
            shape="rounded"
          />
        </Box>
      )}
      <Snackbar
        open={toast.open}
        autoHideDuration={4000}
        onClose={handleCloseToast}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
      >
        <Alert onClose={handleCloseToast} severity={toast.severity} sx={{ width: '100%' }}>
          {toast.message}
        </Alert>
      </Snackbar>
    </Box>
  );
}
